import { render, staticRenderFns } from "./DeviceNameTableItem.vue?vue&type=template&id=64f52c72&scoped=true"
import script from "./DeviceNameTableItem.vue?vue&type=script&lang=js"
export * from "./DeviceNameTableItem.vue?vue&type=script&lang=js"
import style0 from "./DeviceNameTableItem.vue?vue&type=style&index=0&id=64f52c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f52c72",
  null
  
)

export default component.exports